<template>
  <no-auth-layout @back="goBack">
    <div class="pt-[32px] px-[24px]">
      <!-- STEP 1 -->
      <ContactForm v-if="step === 1" @next="showSuccessMessage" />
      <!-- STEP 2 -->
      <ContactSuccess v-if="step === 2" />
    </div>
  </no-auth-layout>
</template>
<script>
import NoAuthLayout from '@/components/NoAuth.vue';
import ContactForm from '@/components/ForgotEmail/ContactForm.vue';
import ContactSuccess from '@/components/ForgotEmail/ContactSuccess.vue';

export default {
  components: {
    NoAuthLayout,
    ContactForm,
    ContactSuccess,
  },
  data() {
    return {
      step: 1,
    };
  },
  methods: {
    showSuccessMessage() {
      this.step = 2;
    },
    goBack() {
      if (this.step > 1) {
        this.step = 1;
      } else {
        this.$router.push('/login');
      }
    },
  },
};
</script>
